import { Component, OnInit } from '@angular/core';
import { FormBuilder, FormGroup, Validators } from '@angular/forms';
import { AuthenticationService } from '../_services/authentication.service';

@Component({
  selector: 'app-loan-request-form',
  templateUrl: './loan-request-form.component.html',
  styleUrls: ['./loan-request-form.component.scss']
})
export class LoanRequestFormComponent implements OnInit {

  loanRequestForm: FormGroup;

  formData = {
    name: "",
    email: "",
    phone: "",
    cantidad: null,
    loanType: ""
  }

  firstForm: FormGroup;

  formReady = 1;

  solicitante:any;

  constructor(private _fb: FormBuilder, private authService: AuthenticationService) { }

  ngOnInit(): void {
    this.loanRequestForm = this._fb.group({
      proposito: ["",[Validators.required]],
      comoSeEntero: ["",[Validators.required]],
      cantidad: [null,[Validators.required]],
      loanType:["",[Validators.required]],
      createdDate: new Date(),
    });
    this.firstForm = this._fb.group({
      name1: ["",[Validators.required]],
      email1: ["",[Validators.required]],
      phone1: ["",[Validators.required]],
      qty1:["",[Validators.required]],
      loan1: ["",[Validators.required]]
    });
  }

  firstFormSubmit(){
    this.solicitante = {name: this.formData.name, email: this.formData.email, address:{celPhone: this.formData.phone}}
    
    this.formReady = 2;
  }

  secondFormSubmit(){
    console.log(this.loanRequestForm.getRawValue());
    let data = this.loanRequestForm.getRawValue();
    data.solicitante = JSON.stringify(data.solicitante);

    this.authService.startLoan(data).then((res:any) => {
      console.log(res);
      this.formReady = 3;
    }, (err:any) => console.log(err));
  }

  addChildForm(name: string, group: FormGroup) {
    console.log(name);
    this.loanRequestForm.addControl(name, group);
  }

}
